import './_buttons.scss';
import { responsive, debounce } from '../../../utilities';

$(() => {
    // scale all consistent primary buttons
    const $primaryButtons = $('.button.button--primary.button--consistent');
    function resize() {
        $primaryButtons.removeAttr('style');
        let scale = 1;
        $primaryButtons.each((_, primaryButton) => {
            const tempScale = responsive.overflownTextScale(primaryButton);
            if (tempScale && tempScale <= 1) {
                scale = tempScale;
            }
        });

        $primaryButtons.css('transform', `scale(${scale})`);
        $primaryButtons.css('transform-origin', 'center left');
    }

    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
